module.exports = __webpack_public_path__ + "static/media/bbc2_cover.a90e5f33.png";